import React from 'react';

export default function IconPH() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 21">
            <path
                fill="#F5F5F5"
                d="M.203 20.526 16 10.5.204.474A.52.52 0 0 0 0 .88v19.242a.52.52 0 0 0 .203.405Z"
            />
            <path
                fill="#FF4B55"
                d="M.203 20.526c.096.077.214.13.348.13h30.897c.305 0 .552-.24.552-.535V10.5H16L.203 20.526Z"
            />
            <path
                fill="#41479B"
                d="M.203.474a.552.552 0 0 1 .348-.13h30.897c.305 0 .552.24.552.535V10.5H16L.203.474Z"
            />
            <path
                fill="#FFE15A"
                d="M5.794 12.237c.99 0 1.793-.778 1.793-1.737 0-.96-.802-1.737-1.793-1.737-.99 0-1.793.778-1.793 1.737 0 .96.803 1.737 1.793 1.737Z"
            />
            <path
                fill="#FFE15A"
                d="m5.794 10.5-.672-2.606.672-.868.673.868-.673 2.606ZM5.794 10.5l.673 2.606-.673.868-.672-.868.672-2.606Z"
            />
            <path
                fill="#FFE15A"
                d="m5.794 10.5-2.69.651-.896-.651.897-.651 2.69.65ZM5.794 10.5l2.69-.651.896.65-.896.652-2.69-.651Z"
            />
            <path
                fill="#FFE15A"
                d="m5.794 10.5 1.427-2.303 1.11-.154-.16 1.075L5.795 10.5ZM5.795 10.5l-1.427 2.303-1.11.154.16-1.075L5.794 10.5Z"
            />
            <path
                fill="#FFE15A"
                d="M5.795 10.5 3.417 9.118 3.26 8.043l1.11.154L5.794 10.5ZM5.794 10.5l2.378 1.382.158 1.075-1.11-.154L5.795 10.5ZM1.48 2.974l.093.675-.63.305a.091.091 0 0 0 .026.172l.692.123.104.674c.014.088.134.108.177.03l.335-.6.694.113c.09.014.147-.09.084-.154l-.485-.494.324-.605c.042-.078-.043-.163-.125-.125l-.634.295-.494-.486c-.064-.063-.173-.01-.161.077ZM1.758 16.125l-.118.672-.695.11a.091.091 0 0 0-.029.171l.623.317-.107.674c-.014.087.095.141.16.08l.503-.477.629.307c.081.04.168-.044.128-.123l-.313-.61.496-.485c.064-.062.009-.168-.081-.155l-.697.099-.322-.607c-.041-.078-.162-.06-.177.027ZM12.672 9.504l-.405.558-.676-.19c-.087-.026-.157.072-.102.142l.422.546-.396.563c-.051.073.023.168.11.14l.665-.221.43.539c.057.07.172.03.17-.058l-.01-.682.662-.23a.091.091 0 0 0-.004-.174l-.672-.201-.022-.682c-.002-.088-.12-.122-.172-.05Z"
            />
        </svg>
    );
}
